import { createFileRoute } from '@tanstack/react-router';

import config from '@@config';
import { requireRoles } from '@@router/guards';

import { Sitemap } from './-components/Sitemap';

export const Route = createFileRoute('/_authenticated/sitemaps')({
    beforeLoad: requireRoles(config.navigation.sitemaps.authorize),
    component: Sitemap,
});
